import React from "react";
import { useQuery } from "@tanstack/react-query";
import { adminCommonCategoryList } from "@/entities";

export function AdminCommonCategoriesSelect({
  table,
  slug,
  defalutValue,
  onChange,
  value,
}: any) {
  const { isLoading, data } = useQuery({
    queryKey: [
      `admin-common-categories`,
      { table, slug, page: 1, perPage: 100 },
    ],
    queryFn: () =>
      adminCommonCategoryList({ table, slug, page: 1, perPage: 100 }),
  });

  return (
    <select
      className="form-select form-select-md"
      onChange={onChange}
      value={value}
    >
      <option value={defalutValue.key}>{defalutValue.value}</option>
      {!isLoading &&
        data?.result.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          );
        })}
    </select>
  );
}
